module.exports = __webpack_public_path__ + "img/header_philosophie_2.fa788d70.jpg";